module.exports = __webpack_public_path__ + "static/media/show.779644d8.svg";